import doubleOptModule from './double-opt-dialog/double-opt.module';
import dropdownModule from './dropdown/dropdown.module';
import fizyLogoModule from './fizy-logo/fizy-logo.module';
import footerModule from './footer/footer.module';
import HeaderMenuDropdown from './header-menu-dropdown/header-menu-dropdown.module';
import headerModule from './header/header.module';
import loginModule from './login-dialog/login-components.module';
import packetCardModule from './packet-card/packet-card.module';
import paycellInfoLink from './paycell-info-link/paycell-info-link.module';
import paymentProgressModule from './payment-progress/payment-progress.module';
import socialMediaModule from './social-media/social-media.module';
import spinnerModule from './spinner/spinner.module';
import tcNoDirective from './tc-no/tc-no.directive';
import navBarModule from './nav-bar/nav-bar.module';
import onErrorSrcDirective from './onErrorSrc/on-error-src.directive';
import yearlyContractedDialogModule from '../buy/yearly-contracted-info/yearly-contracted-dialog.module';
import yearlyDialogModule from '../buy/yearly-info/yearly-dialog.module';
import campaignDialogModule from '../components/campaign-dialog/campaign-dialog.module';
import studentNoSubModule from './student/nosub/nosub.module';
import studentReviewModule from './student/reviewing/reviewing.module';
import studentRejectedModule from './student/rejected/rejected.module';
import studentReceivedModule from './student/received/received.module';
import studentSuccessModule from './student/successful/successful.module';
import studentBlockedModule from './student/blocked/blocked.module';
import studentLimitExceededModule from './student/limit-exceeded/limit-exceeded.module';
import studentQuotaExceededModule from './student/quota-exceeded/quota-exceeded.module';
import promocodeModule from './promocode/promocode.module';
import promocodeRedirectModule from './promocode-redirect/promocode-redirect.module';
import promocodeHasPackageModule from './promocode-has-package/promocode-has-package.module';

export default angular
  .module('fizyweb.paycell.components', [
    headerModule,
    footerModule,
    paymentProgressModule,
    packetCardModule,
    navBarModule,
    loginModule,
    doubleOptModule,
    dropdownModule,
    spinnerModule,
    fizyLogoModule,
    socialMediaModule,
    paycellInfoLink,
    HeaderMenuDropdown,
    yearlyContractedDialogModule,
    yearlyDialogModule,
    campaignDialogModule,
    promocodeModule,
    promocodeRedirectModule,
    promocodeHasPackageModule,

    studentNoSubModule,
    studentReviewModule,
    studentReceivedModule,
    studentRejectedModule,
    studentSuccessModule,
    studentBlockedModule,
    studentLimitExceededModule,
    studentQuotaExceededModule
  ])
  .directive('tcNo', tcNoDirective)
  .directive('onErrorSrc', onErrorSrcDirective).name;



// WEBPACK FOOTER //
// src/app/components/components.module.ts